import React from 'react'
import { styled } from '@mui/material'
import Switch from '@mui/material/Switch'

import { baseColor } from '#/shared/lib/constants/colors'
import { pingFangFont } from '#/shared/lib/constants/font/font'

const AntSwitch = styled(Switch)(({ theme }) => ({
	width: 29,
	height: 17,
	padding: 0,
	display: 'flex',
	'&:active': {
		'& .MuiSwitch-thumb': {
			width: 17,
		},
		'& .MuiSwitch-switchBase.Mui-checked': {
			transform: 'translateX(9px)',
		},
	},
	'& .MuiSwitch-switchBase': {
		padding: 2.6,
		'&.Mui-checked': {
			transform: 'translateX(12px)',
			color: 'white',
			'& + .MuiSwitch-track': {
				opacity: 1,
				backgroundColor: '#177ddc',
			},
		},
	},
	'& .MuiSwitch-thumb': {
		boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
		width: 12,
		height: 12,
		borderRadius: 10,
		transition: theme.transitions.create(['width'], {
			duration: 100,
		}),
	},
	'& .MuiSwitch-track': {
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: 'rgba(255,255,255,.35)',
		boxSizing: 'border-box',
	},
}))
export const SwitchCustom = (props: any) => {
	return (
		<AntSwitch
			sx={{
				'& .MuiSwitch-track': {
					borderRadius: 16 / 2,
					opacity: 1,
					backgroundColor: '#40404E',
					boxSizing: 'border-box',
				},
			}}
			{...props}
			inputProps={{ 'aria-label': 'ant design' }}
		/>
	)
}
